import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';

export type StatusToggleProps = {
  className?: string;
  optionClassName?: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export default function StatusToggle({
  className,
  optionClassName,
  value,
  onChange,
}: StatusToggleProps) {
  return (
    <ToggleBlock<boolean>
      className={className}
      value={value}
      onChange={onChange}>
      <ToggleOption className={optionClassName} value={true}>
        All
      </ToggleOption>
      <ToggleOption className={optionClassName} value={false}>
        Open
      </ToggleOption>
    </ToggleBlock>
  );
}
